import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OrganizationsNavigationProvider } from '../providers/navigation-provider';
import { CurrentUser } from "../../common/providers/current-user";
import { IsLoggedInGuard, IsLoggedInService } from "../../common/guards/is-logged-in";
import { Observable, of, switchMap } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class IsOrganizationMemberGuard implements CanActivate {
    constructor(
        private _currentUser: CurrentUser,
        private _isLoggedIn: IsLoggedInService,
        private _router: Router,
        private _navigation: OrganizationsNavigationProvider,
    ) {
    }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._isLoggedIn.runIsLoggedIn(route).pipe(
      switchMap(isLoggedIn => {
        if (!isLoggedIn) {
          this.redirect();
          return of(false);
        }
        return this._navigation.getOrganisationFromRoute('/' + route.url.map(segment => segment.path).join('/')).pipe(
          switchMap(organization => {
            if (!organization) {
              this.redirect();
              return of(false);
            }
            return this._currentUser.getOrganizationsMemberships().pipe(
              map(memberships => {
                const isMember = memberships.some(membership => membership.organizationId === organization.id);
                if (!isMember) {
                  this.redirect();
                  return false;
                }
                return true;
              })
            );
          })
        );
      }),
      catchError(error => {
        this.redirect();
        return of(false);
      })
    );
  }

  private redirect(): void {
        this._router.navigate(['401']);
    }

}
